import { render, staticRenderFns } from "./TagItem.vue?vue&type=template&id=537529ac&scoped=true"
import script from "./TagItem.vue?vue&type=script&lang=js"
export * from "./TagItem.vue?vue&type=script&lang=js"
import style0 from "./TagItem.vue?vue&type=style&index=0&id=537529ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537529ac",
  null
  
)

export default component.exports